import { Link } from 'react-router-dom';

import {
  GAME, isPromoted, phaseAt, dateLabel, START_DAY, END_DAY, DRAW_DAY,
} from '../utils/christmasGame';
import '../styles/christmas-game.css';

const TEXT = {
  soon: [
    `Коледното колело тръгва на ${dateLabel(START_DAY)}`,
    'Всеки ден – шанс за отстъпка, безплатна доставка или подарък.',
    'Научи повече',
  ],
  live: [
    'Завъртя ли коледното колело днес?',
    `Отстъпка, безплатна доставка или подарък към поръчката. Всеки ден до ${dateLabel(END_DAY)}.`,
    'Завърти',
  ],
  ended: [
    `Тегленето на коледната тениска е на ${dateLabel(DRAW_DAY)}`,
    'Благодарим на всички, които въртяха колелото.',
    'Подробности',
  ],
};

export const ChristmasBanner = () => {
  const now = Date.now();
  if (!isPromoted(now)) return null;
  const [title, text, cta] = TEXT[phaseAt(now)];
  return (
    <div className="xg-banner">
      <p>
        <strong>🎄 {title}</strong>
        <span className="xg-banner-sub">{text}</span>
      </p>
      <Link className="xg-btn" to={GAME.path}>{cta}</Link>
    </div>
  );
};
